import {Router} from '@angular/router';
import {JwtHelperService} from '@auth0/angular-jwt';
import {environment} from '~env/environment';

export enum Paths {
  LOGIN = 'login',
  GRID = 'grid',
  MAPA = 'mapa',
  ADMIN_VISITAS = 'administrar-visitas',
  ADMIN_CARREGAMENTO = 'administrar-carregamento',
  CONFIG = 'configuracoes',
  SEGURANCA = 'seguranca',
  IMPORTACAO = 'importacao',
  GRUPOUSUARIO = 'grupo-usuario',
  RELATORIO = 'relatorio',
  RELATORIOS = 'relatorios',
  ROTA = 'rota',
  FINANCEIRO = 'financeiro',
  DASHBOARD = 'dashboard',
  CHAT = 'chat',
  TALKS = 'talks',
  ALERTAS_INCIDENTES = 'alertas',
  REPROGRAMACAO = 'reprogramacao',
  PRINT = 'print',
  NAO_AUTORIZADO = '403',
  PORTAL_CLIENTE= 'portal-cliente'
}

export type Scopes = {[rule: string]: RolesConfig};

const excludeChat = environment.experimentalFeatures?.showChat ? [] : [Paths.CHAT];
const excludeOperador = [Paths.FINANCEIRO, Paths.ADMIN_CARREGAMENTO, Paths.SEGURANCA].concat(excludeChat);
export const RolesAccess: Scopes = {
  Operador: {include: '*', exclude: excludeOperador, defaultPage: Paths.GRID},
  Financeiro: {include: [Paths.FINANCEIRO], defaultPage: Paths.FINANCEIRO},
  Admin: {include: [Paths.CONFIG, Paths.SEGURANCA], defaultPage: Paths.CONFIG},
  Custom: {include: '*', defaultPage: Paths.CONFIG},
};

export const getDetailsScopes = (jwt: JwtHelperService, tokenRules: string): {scopes: Scopes, theme?: string} => {
  return (!jwt.isTokenExpired(tokenRules) ? jwt.decodeToken(tokenRules) : {scopes: RolesAccess}) as {scopes: Scopes, theme?: string};
};

export interface RolesConfig {
  include: Paths[] | '*';
  exclude?: Paths[];
  defaultPage: Paths;
}

export const checkRoles = (path: string, roles: string[], scopes: Scopes, router?: Router): boolean => {
  const page = Paths.NAO_AUTORIZADO;
  if (path.startsWith('/' + Paths.LOGIN)) {
    return true;
  }

  const map = roles.map(role => {
    // const {exclude, include, defaultPage} = scopes.Custom;
    const {exclude, include, defaultPage} = roles.includes("Custom") ? scopes.Custom : scopes[role];
    const result = {defaultPage: defaultPage || page, allow: false};
    const deny = exclude?.find((p:any) => path.startsWith('/' + p));
    const allow = include === '*' || !!include?.find((p:any) => path.startsWith('/' + p));
    result.allow = !deny && allow;
    return result;
  });
  const find = map.find(r => r.allow);
  if (find?.allow) {
    return true;
  }
  router?.navigate(['/' + (map.find(v => v)?.defaultPage || page)]).then();
  return false;
};
